import React from "react";
import PropTypes from "prop-types";
import ReactInterval from "react-interval";
import "moment/locale/ru";
import Moment from "react-moment";
// import material-ui components
import { withStyles } from "@material-ui/styles";
import TablePagination from "@material-ui/core/TablePagination";
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";
//import @material-ui/icons
import ApplyIcon from "@material-ui/icons/Done";
import MoreIcon from "@material-ui/icons/MoreHoriz";
import AddIcon from "@material-ui/icons/Add";
//redux components
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
//import core components
import Button from "components/CustomButtons/Button.jsx";
import Table from "components/Table/Table.jsx";
import NewReportDialog from "components/Dialogs/NewReportDialog";
import { getStatusFromCode, roles } from "utils/misc";
import { get_report_apply, post_report } from "../../utils/http";

import usersStyle from "assets/jss/material-dashboard-react/views/usersStyle"

import * as actionCreators from "actions/reports";
import {history} from "../../history";

function mapStateToProps(state) {
    return {
        token: state.auth.token,
        userRole: state.auth.role,
        reports: state.reports.reports,
        reportsNotAccepted: state.reports.reportsNotAccepted,
        reportsActive: state.reports.reportsActive,
        reportsSubjects: state.reports.subjects.data,
        reportsMachines: state.reports.machines.data,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch);
}

class ReportsView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            timeoutEnabled: false,
            reportsData: [],
            reportsRowsPerPage: 25,
            reportsPage: 1,
            reportsNotAcceptedData: [],
            reportsNotAcceptedPage: 1,
            reportsNotAcceptedRowsPerPage: 25,
            reportsActiveData: [],
            reportsActivePage: 1,
            reportsActiveRowsPerPage: 25,
            newReportDialogIsOpened: false,
        };
    }

    componentWillReceiveProps(nextProps, nextContext){
        const { classes } = this.props;
        this.setState((prevState) => ({
            ...prevState,
            reportsData: nextProps.reports.isLoaded ? nextProps.reports.data.map((prop) => (
                [prop.id, prop.name, prop.machine_id, prop.machine_address, prop.subject,
                    prop.assigned_to_user ,getStatusFromCode(prop.status_id),
                    (<Moment format="DD/MM/YYYY HH:mm:ss">{prop.creation_time}</Moment>) ,
                    (<div>
                        <Button justIcon round simple color="transparent" className={classes.tableButton}
                                onClick={() => {ReportsView.redirectToReportPage(prop.id)}}
                        >
                            <MoreIcon/>
                        </Button>
                    </div>)]
            )) : prevState.reportsData,
            reportsNotAcceptedData: nextProps.reportsNotAccepted.isLoaded ? nextProps.reportsNotAccepted.data.map((prop) => (
                [prop.id, prop.name, prop.machine_id, prop.machine_address, prop.subject,
                    (<Moment format="DD/MM/YYYY HH:mm:ss">{prop.creation_time}</Moment>),
                    (<div>
                        {(this.props.userRole === roles[3] || this.props.userRole === roles[0])
                        && <Button color="success"  size="sm" className={classes.tableButton}
                                   onClick={() => this.applyReport(prop.id)}>
                            <ApplyIcon/>Принять
                        </Button>}
                        <Button justIcon round simple color="transparent" className={classes.tableButton}
                                onClick={() => {ReportsView.redirectToReportPage(prop.id)}}
                        >
                            <MoreIcon/>
                        </Button>
                    </div>)]
            )) : prevState.reportsNotAcceptedData,
            reportsActiveData: nextProps.reportsActive ? nextProps.reportsActive.data.map((prop) => (
                [prop.id, prop.name, prop.machine_id, prop.machine_address, prop.subject,
                    (<Moment format="DD/MM/YYYY HH:mm:ss">{prop.creation_time}</Moment>),
                    (<div>
                        <Button justIcon round simple color="transparent" className={classes.tableButton}
                                onClick={() => {ReportsView.redirectToReportPage(prop.id)}}
                        >
                            <MoreIcon/>
                        </Button>
                    </div>)]
            )) : prevState.reportsActiveData,
        }))
    }

    componentDidMount(){
        this.setState({
            timeoutEnabled: true
        });
        this.getData()
    }

    componentWillUnmount(){
        this.setState({
            timeoutEnabled: false,
        })
    }

    getData(){
        this.props.getReports(this.props.token, this.state.reportsPage, this.state.reportsRowsPerPage);
        this.props.getReportsNotAccepted(this.props.token, this.state.reportsNotAcceptedPage, this.state.reportsNotAcceptedRowsPerPage);
        this.props.getReportsActive(this.props.token, this.state.reportsActivePage, this.state.reportsActiveRowsPerPage);
        this.props.getReportsMachines(this.props.token);
        this.props.getReportsSubjects(this.props.token);
    }


    handleReportsChangePage(page, type=""){
        this.setState({
            [`reports${type}Page`]: page
        }, this.getData)
    }

    handleReportsChangeRowsPerPage(e, type=""){
        if (e.target.value !== this.state.usersRowsPerPage) {
            this.setState({
                [`reports${type}RowPerPage`]: e.target.value
            }, this.getData);
        }
    }

    applyReport(id){
        get_report_apply(this.props.token, id);
        this.getData()
    }

    newReportDialogOpen(){
        this.setState({
            newReportDialogIsOpened: true,
        })
    }

    newReportDialogClose(){
        this.setState({
            newReportDialogIsOpened: false,
        })
    }

    createReport(report){
        this.newReportDialogClose();
        post_report(this.props.token, {
            report_subject_id: report.reportSubjectId,
            machine_id: report.machineId,
            name: report.name,
            description: report.description,
        });
        this.getData();
    }

    static redirectToReportPage(id){
        history.push(`/reports/${id}/`)
    }

    render(){
        const { classes } = this.props;
        return (
            <div>
                <CustomTabs
                    title="ЗАЯВКИ:"
                    headerColor="info"
                    headerRight={(
                        <Button color="info" className={classes.headerButton} onClick={() => this.newReportDialogOpen()}>
                            <AddIcon className={classes.icons}/>Новая
                        </Button>
                    )}
                    tabs={[
                        {
                            tabName: "Открытые",
                            tabContent: (
                                <Table
                                    tableHead={["ID", "Название", "ID аппарата", "Адрес аппарата", "Тема", "Время создания", ""]}
                                    tableData={this.state.reportsNotAcceptedData}
                                    tablePagination={(<TablePagination count={this.props.reportsNotAccepted.count || 0}
                                                                       onChangePage={(e, page) => this.handleReportsChangePage(page + 1, "NotAccepted")}
                                                                       page={this.state.reportsNotAcceptedPage - 1} rowsPerPage={this.state.reportsNotAcceptedRowsPerPage}
                                                                       labelDisplayedRows={({from, to, count}) => `${from}-${to} из ${count}`}
                                                                       labelRowsPerPage="Строк на страницу:" component="div"
                                                                       onChangeRowsPerPage={(e) => this.handleReportsChangeRowsPerPage(e, "NotAccepted")}
                                    />)}
                                />
                            )
                        },
                        (this.props.userRole === roles[3] || this.props.userRole === roles[0])
                        ? {
                            tabName: "Мои",
                            tabContent: (
                                <Table
                                    tableHead={["ID", "Название", "ID аппарата", "Адрес аппарата", "Тема", "Время создания", ""]}
                                    tableData={this.state.reportsActiveData}
                                    tablePagination={(<TablePagination count={this.props.reportsActive.count || 0}
                                                                       onChangePage={(e, page) => this.handleReportsChangePage(page + 1, "Active")}
                                                                       page={this.state.reportsActivePage - 1} rowsPerPage={this.state.reportsActiveRowsPerPage}
                                                                       labelDisplayedRows={({from, to, count}) => `${from}-${to} из ${count}`}
                                                                       labelRowsPerPage="Строк на страницу:" component="div"
                                                                       onChangeRowsPerPage={(e) => this.handleReportsChangeRowsPerPage(e, "Active")}
                                    />)}
                                />
                            )
                        } : null,
                        {
                            tabName: "Все",
                            tabContent: (
                                <Table
                                    tableHead={["ID", "Название", "ID аппарата", "Адрес аппарата", "Тема", "Выполнил", "Статус", "Время создания", ""]}
                                    tableData={this.state.reportsData}
                                    tablePagination={(<TablePagination count={this.props.reports.count || 0}
                                                                       onChangePage={(e, page) => this.handleReportsChangePage(page + 1)}
                                                                       page={this.state.reportsPage - 1} rowsPerPage={this.state.reportsRowsPerPage}
                                                                       labelDisplayedRows={({from, to, count}) => `${from}-${to} из ${count}`}
                                                                       labelRowsPerPage="Строк на страницу:" component="div"
                                                                       onChangeRowsPerPage={(e) => this.handleReportsChangeRowsPerPage(e)}
                                    />)}
                                />
                            )
                        }
                    ]}
                />
                <NewReportDialog isOpened={this.state.newReportDialogIsOpened}
                                 subjects={this.props.reportsSubjects} machines={this.props.reportsMachines}
                                 onSave={(report) => this.createReport(report)} onCancel={() => this.newReportDialogClose()}/>
                <ReactInterval timeout={15000} enabled={this.state.timeoutEnabled} callback={() => this.getData()}/>
            </div>
        )
    }
}

ReportsView.propTypes = {
    getReports: PropTypes.func,
    getReportsNotAccepted: PropTypes.func,
    getReportsActive: PropTypes.func,
    getReportsSubjects: PropTypes.func,
    getReportsMachines: PropTypes.func,
    token: PropTypes.string,
    reports: PropTypes.shape({
        isLoading: PropTypes.bool,
        isLoaded: PropTypes.bool,
        data: PropTypes.array,
        count: PropTypes.number,
        pages: PropTypes.number,
        page: PropTypes.number,
    }),
    reportsNotAccepted: PropTypes.shape({
        isLoading: PropTypes.bool,
        isLoaded: PropTypes.bool,
        data: PropTypes.array,
        count: PropTypes.number,
        pages: PropTypes.number,
        page: PropTypes.number,
    }),
    reportsActive: PropTypes.shape({
        isLoading: PropTypes.bool,
        isLoaded: PropTypes.bool,
        data: PropTypes.array,
        count: PropTypes.number,
        pages: PropTypes.number,
        page: PropTypes.number,
    }),
    reportsSubjects: PropTypes.array,
    reportsMachines: PropTypes.array,
};

export default withStyles(usersStyle)(connect(mapStateToProps, mapDispatchToProps)(ReportsView));


// WEBPACK FOOTER //
// ./src/views/Reports/Reports.jsx